import './modules/panels';
